import { FC } from 'react'
import styles from './Pod4Benefits.module.scss'
import { Pod4BenefitsProps } from './types'
import { getTemperature } from 'components/_utils/temperatureUtils'

export const Pod4Benefits: FC<Pod4BenefitsProps> = (props) => {
	const { metric } = props

	const lowTemp = getTemperature(55, metric)
	const highTemp = getTemperature(110, metric)

	const benefits = [
		{ value: '2x', text: 'Twice the cooling power vs previous Pod generation.' },
		{ value: lowTemp.slice(0, -1), text: `Cools your bed to as low as ${lowTemp}.` },
		{ value: highTemp.slice(0, -1), text: `Heats your bed to as high as ${highTemp}.` },
	]

	const Benefit = (prop: { value: string; text: string }) => {
		return (
			<div className={styles.benefit}>
				<div className={styles.benefitValue}>{prop.value}</div>
				<div className={styles.benefitText}>{prop.text}</div>
			</div>
		)
	}
	return (
		<div className={styles.container}>
			{benefits.map((benefit, i) => (
				<Benefit
					key={`pod4-benefit-${i}`}
					value={benefit.value}
					text={benefit.text}
				/>
			))}
		</div>
	)
}
